<template>
  <div>
    <el-card shadow="always">
      <el-page-header
        title
        @back="$router.push('/home').catch(() => {})"
        :content="$t('conferencia-objetos')"
      ></el-page-header>
    </el-card>
    <el-card>
      <el-form :model="ruleForm" ref="ruleForm" label-position="top">
        <el-row :gutter="5">
          <el-col :xs="12" :sm="6" :md="6" :lg="5" :xl="5">
            <el-form-item :label="$t('objeto')" prop="object">
              <el-input
                @blur="get()"
                ref="name"
                v-model="ruleForm.object"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="6" :md="6" :lg="5" :xl="5">
            <el-form-item :label="$t('tipo')" prop="type">
              <el-select
                placeholder="Selecione um tipo de objeto"
                v-model="ruleForm.type"
              >
                <el-option key="003" label="Envelope" value="003"></el-option>
                <el-option
                  key="001"
                  label="Pacote / Caixa"
                  value="001"
                ></el-option>
                <el-option
                  key="002"
                  label="Rolo / Cilindro / Esférico"
                  value="002"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="12" :md="12" :lg="4" :xl="4">
            <el-form-item :label="$t('peso-g')" prop="weight">
              <el-input ref="name" v-model="ruleForm.weight"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="4" :xl="4">
            <el-form-item :label="$t('altura-cm')" prop="lenght">
              <el-input ref="name" v-model="ruleForm.length"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="4" :xl="4">
            <el-form-item :label="$t('largura-cm')" prop="width">
              <el-input ref="name" v-model="ruleForm.width"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="4" :xl="4">
            <el-form-item :label="$t('comprimento-cm')" prop="size">
              <el-input ref="name" v-model="ruleForm.height"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="4" :xl="4">
            <el-form-item :label="$t('valor-decl')" prop="value">
              <el-input ref="name" v-model="ruleForm.value"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <br />
        <el-form-item>
          <el-button type="warning" autofocus @click="submitForm('ruleForm')">{{
            $t("atualizar")
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>
<script>
//import { UserService } from "@/services/users/user.services";
import { i18n } from "@/plugin/i18n";
import { PrepostService } from "@/services/customers/prepost.services";

export default {
  name: "LoadObjectsCheck",
  methods: {
    get() {
      const vm = this;
      if (vm.ruleForm.object) {
        const loading = vm.$loading({
          lock: true,
          text: i18n.tc("carregando"),
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        PrepostService.tag(vm.ruleForm.object)
          .then((response) => {
            vm.ruleForm.weight = response.weight;
            vm.ruleForm.length = response.length;
            vm.ruleForm.width = response.width;
            vm.ruleForm.height = response.height;
            vm.ruleForm.value = response.pricetable;
            vm.ruleForm.type = response.type;
          })
          .catch((error) => {
            this.$message({
              type: "error",
              message: error,
            });
          })
          .finally(() => loading.close());
      }
    },
    submitForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading({
            lock: true,
            text: i18n.tc("carregando"),
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          PrepostService.check(vm.ruleForm)
            .then(() => {
              this.$message({
                type: "success",
                message: "Objeto atualizado com sucesso!",
              });
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
  },
  data() {
    return {
      ruleForm: {
        type: "001",
        object: "",
        weight: 0,
        length: 0,
        width: 0,
        height: 0,
        value: 0,
      },
    };
  },
};
</script>
<style>
.right {
  float: right;
}
.label {
  font-weight: bold;
}
</style>